export default __webpack_public_path__ + "static/media/cloud.e104f095.png";